// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.notifications--container[data-v-69246b2e]{height:100%;width:100%;position:fixed;bottom:0;right:0;z-index:9;pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
